import React from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { Container } from "./styles";

export const LoadingSpinner = (
  <Container>
    <ClipLoader
      color="#FF2D2E"
      size="85px"
      aria-label="Loading Spinner"
      data-testid="loader"
    />
  </Container>
);
